export const ORCH_ENDPOINT_PATH = process.env.ORCH_ENDPOINT_PATH || '';
export const RAILS_ENDPOINT_PATH = process.env.RAILS_ENDPOINT_PATH || '';
export const AUTH_ENDPOINT_PATH = process.env.AUTH_ENDPOINT_PATH || '';
/* eslint-disable prefer-destructuring */
export const LOGIN_UI_PATH = process.env.LOGIN_UI_PATH;
export const APP_PATH = process.env.ALB_PATH;
/* eslint-enable */



// WEBPACK FOOTER //
// ./src/config.js